module.exports = __webpack_public_path__ + "img/download-txt.dc6db785.png";